import { useQuery } from "@tanstack/react-query";
import { attendanceMapService } from "../services/attendance-map.service";
import type { AttendanceMapLiveParams } from "../types";

export const attendanceMapKeys = {
	all: ["attendance-map"] as const,
	live: (params?: AttendanceMapLiveParams) => [...attendanceMapKeys.all, "live", params] as const,
};

export function useAttendanceMapLive(
	params?: AttendanceMapLiveParams,
	options?: { enabled?: boolean }
) {
	return useQuery({
		queryKey: attendanceMapKeys.live(params),
		queryFn: () => attendanceMapService.getLive(params),
		refetchInterval: 30_000,
		enabled: options?.enabled ?? true,
	});
}
